import React, { useState } from 'react';
import axios from 'axios';
import './App.css';

function App() {
  const [url, setUrl] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [clinicName, setClinicName] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<any>(null);
  const [voiceResult, setVoiceResult] = useState<any>(null);
  const [error, setError] = useState('');
  const [activeTab, setActiveTab] = useState('audit'); // 'audit' or 'voice'

  const handleScan = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setResult(null);
    try {
      const response = await axios.post('https://bencorp-audit-api.bengrindsfx.workers.dev/scan', { url });
      setResult(response.data);
    } catch (err: any) {
      setError(err.response?.data?.detail || 'An error occurred during the scan.');
    } finally {
      setLoading(false);
    }
  };

  const handleVoiceDemo = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setVoiceResult(null);
    try {
      const response = await axios.post('https://bencorp-audit-api.bengrindsfx.workers.dev/voice-demo', { 
        phone_number: phoneNumber,
        clinic_name: clinicName 
      });
      setVoiceResult(response.data);
    } catch (err: any) {
      setError('Failed to trigger voice demo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <div className="container">
          <h1 className="logo">BENCORP AI</h1>
          <p className="subtitle">Institutional Automation Lab</p>
          
          <div className="tab-container">
            <button 
              className={`tab-button ${activeTab === 'audit' ? 'active' : ''}`}
              onClick={() => setActiveTab('audit')}
            >
              Compliance Audit
            </button>
            <button 
              className={`tab-button ${activeTab === 'voice' ? 'active' : ''}`}
              onClick={() => setActiveTab('voice')}
            >
              Voice Agent Demo
            </button>
          </div>

          {activeTab === 'audit' ? (
            <div className="tab-content">
              <form onSubmit={handleScan} className="scan-form">
                <input 
                  type="url" 
                  placeholder="https://company-website.com" 
                  value={url}
                  onChange={(e) => setUrl(e.target.value)}
                  required 
                  className="scan-input"
                />
                <button type="submit" disabled={loading} className="scan-button">
                  {loading ? 'Scanning...' : 'Run Free Audit'}
                </button>
              </form>

              {result && (
                <div className="results-container animate-in">
                  <div className="score-box">
                    <span className="score-label">Compliance Score</span>
                    <span className={`score-value ${result.compliance_score > 7 ? 'good' : 'bad'}`}>
                      {result.compliance_score}/10
                    </span>
                  </div>
                  <div className="gaps-list">
                    <h3>Identified Gaps</h3>
                    {result.gaps.map((gap: any, index: number) => (
                      <div key={index} className="gap-item">
                        <strong>{gap.description}</strong>
                        <p className="risk-text">Liability: {gap.fine_risk}</p>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="tab-content">
              <div className="voice-demo-box animate-in">
                <h3>Experience your AI Receptionist</h3>
                <p>Enter your phone number and we will call you to demonstrate the Dental Clinic agent.</p>
                <form onSubmit={handleVoiceDemo} className="voice-form">
                  <input 
                    type="text" 
                    placeholder="Clinic Name (e.g. PearliWhyte)" 
                    value={clinicName}
                    onChange={(e) => setClinicName(e.target.value)}
                    required 
                    className="scan-input"
                  />
                  <input 
                    type="tel" 
                    placeholder="+260..." 
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    required 
                    className="scan-input"
                  />
                  <button type="submit" disabled={loading} className="scan-button">
                    {loading ? 'Connecting...' : 'Call Me Now'}
                  </button>
                </form>
                {voiceResult && (
                  <div className="voice-success">
                    <p>✅ {voiceResult.message}</p>
                    <p>Get ready to answer!</p>
                  </div>
                )}
              </div>
            </div>
          )}

          {error && <div className="error-message">{error}</div>}
        </div>
      </header>
      <footer className="footer">
        © 2026 Bencorp AI & Automation | Lusaka, Zambia
      </footer>
    </div>
  );
}

export default App;
